import { defineStore } from 'pinia';
import { useMilkomedaWSCUnwrapBridge } from '@/composables/milkomeda-wrapped-smartcontract/useMilkomedaWSCUnwrapBridge';

export const useStakingMilkomedaWSCUnwrapBridge = defineStore(
  'stakingMilkomedaWSCUnwrapBridge',
  () => {
    const milkomedaWSCUnwrapBridge = useMilkomedaWSCUnwrapBridge();

    return {
      ...milkomedaWSCUnwrapBridge,
    };
  },
);
